<div>
    <table class="merge-exam-table">
        <tr>
            <th scope="col">{{'ECG_Source' | translate}}</th>
            <th scope="col">{{'FirstName' | translate}}</th>
            <th scope="col">{{'LastName' | translate}}</th>
            <th scope="col">{{'Sex' | translate}}</th>
            <th scope="col">{{'BirthDate' | translate}}</th>
            <th scope="col">{{'Date' | translate}}</th>
            <th scope="col">{{'ExamNumber' | translate}}</th>
            <th scope="col">{{'Exam' | translate}}</th>
        </tr>
        <tr>
            <th scope="row">{{'ECG_source' | translate }}</th>
            <td [class.difference-in-merge]="mergeExamDifferenceChecker.isFirstNameDifferent()">
                {{mergeExamDifferenceChecker.source?.patient.firstName}}
            </td>
            <td [class.difference-in-merge]="mergeExamDifferenceChecker.isLastNameDifferent()">
                {{mergeExamDifferenceChecker.source?.patient.lastName}}
            </td>
            <td [class.difference-in-merge]="mergeExamDifferenceChecker.isSexDifferent()">
                {{mergeExamDifferenceChecker.source?.patient.sex}}
            </td>
            <td [class.difference-in-merge]="mergeExamDifferenceChecker.isBirthDateDifferent()">
                {{mergeExamDifferenceChecker.source?.patient.birthDate | datetime: 'dd/MM/yyyy'}}
            </td>
            <td [class.difference-in-merge]="mergeExamDifferenceChecker.isDateDifferent()">
                {{mergeExamDifferenceChecker.source?.examinationDate | datetime: 'dd/MM/yyyy HH:mm'}}
            </td>
            <td [class.difference-in-merge]="mergeExamDifferenceChecker.isExamNumberDifferent()">
                {{mergeExamDifferenceChecker.source?.examNumber}}
            </td>
            <td [class.difference-in-merge]="mergeExamDifferenceChecker.isDescriptionDifferent()">
                {{mergeExamDifferenceChecker.source?.exam.description}}
            </td>
        </tr>
        <tr>
            <th scope="row" [class.difference-in-merge]>{{'ECG_target' | translate }}</th>
            <td [class.difference-in-merge]="mergeExamDifferenceChecker.isFirstNameDifferent()">
                {{mergeExamDifferenceChecker.target?.patient.firstName}}
            </td>
            <td [class.difference-in-merge]="mergeExamDifferenceChecker.isLastNameDifferent()">
                {{mergeExamDifferenceChecker.target?.patient.lastName}}
            </td>
            <td [class.difference-in-merge]="mergeExamDifferenceChecker.isSexDifferent()">
                {{mergeExamDifferenceChecker.target?.patient.sex}}
            </td>
            <td [class.difference-in-merge]="mergeExamDifferenceChecker.isBirthDateDifferent()">
                {{mergeExamDifferenceChecker.target?.patient.birthDate | datetime: 'dd/MM/yyyy'}}
            </td>
            <td [class.difference-in-merge]="mergeExamDifferenceChecker.isDateDifferent()">
                {{mergeExamDifferenceChecker.target?.examinationDate | datetime: 'dd/MM/yyyy HH:mm'}}
            </td>
            <td [class.difference-in-merge]="mergeExamDifferenceChecker.isExamNumberDifferent()">
                {{mergeExamDifferenceChecker.target?.examNumber}}
            </td>
            <td [class.difference-in-merge]="mergeExamDifferenceChecker.isDescriptionDifferent()">
                {{mergeExamDifferenceChecker.target?.exam.description}}
            </td>
        </tr>
    </table>
    <div class="warning-footer">
        <mat-icon>warning</mat-icon>
        <h4>{{ 'ECG_MergeExamWarning' | translate }}</h4>
    </div>
</div>
